import React, { useState, useCallback } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import { testimonials, Testimonial } from '../data/content';
function Card({
  t
}: {
  t: Testimonial;
}) {
  return <article className="flex h-full flex-col rounded-2xl border border-cobalt/20 bg-white p-6 shadow-sm shadow-cobalt/5" data-id="element-195" data-mp="3fxb40lzxjwdr">
      <p className="flex-1 text-sm leading-relaxed text-ink/80" data-id="element-196" data-mp="36zilza2tqamo">“{t.text}”</p>
      <div className="mt-6 flex items-center gap-3" data-id="element-197" data-mp="31zw951qwqwee">
        <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-cobalt text-sm font-bold text-white" data-id="element-198" data-mp="31z3c4shr3l9g">
          {t.initials}
        </span>
        <div data-id="element-199" data-mp="2s28cg69qretl">
          <p className="text-sm font-bold text-ink" data-id="element-200" data-mp="2s2rx3uqs0hbb">{t.name}</p>
          <p className="text-xs text-ink/60" data-id="element-201" data-mp="v9g9bl2obyo3">{t.role} · {t.city}</p>
        </div>
      </div>
    </article>;
}
export function Testimonials() {
  const topTestimonials = testimonials.slice(0, 3);
  const [index, setIndex] = useState(0);
  const go = useCallback((dir: number) => {
    setIndex(prev => (prev + dir + topTestimonials.length) % topTestimonials.length);
  }, [topTestimonials.length]);
  return <section className="w-full bg-white px-5 py-6 sm:py-12" data-id="element-202" data-mp="78ab7gzpprhr">
      <div className="mx-auto max-w-5xl" data-id="element-203" data-mp="79v8vfhbpqju">
        <div className="mx-auto max-w-2xl text-center" data-id="element-204" data-mp="c622c8sj99kw">
          <h2 className="font-serif-display text-2xl font-bold leading-tight text-ink sm:text-4xl" data-id="element-205" data-mp="c8y3s73lage3">
            La parola ai docenti di chimica
          </h2>
          <p className="mt-2 text-sm text-ink/70 sm:mt-3 sm:text-base" data-id="element-206" data-mp="14uhiiynehxxt">
            Perché materiali più visivi, organizzati e pronti all’uso possono semplificare concretamente il lavoro quotidiano di chi insegna chimica.
          </p>
        </div>

        <div className="mt-6 hidden gap-6 sm:mt-10 md:grid md:grid-cols-3" data-id="element-207" data-mp="v3d4c15juh41">
          {topTestimonials.map((t, i) => <Card key={i} t={t} data-id="element-208" data-mp="1nmk14fjlroap" data-mpi={i} />)}
        </div>

        <div className="mt-8 md:hidden" data-id="element-209" data-mp="1no3g82tivtaw">
          <div className="relative overflow-hidden" data-id="element-210" data-mp="1xiisiwe1nkip">
            <AnimatePresence mode="wait" data-id="element-211" data-mp="1xfwm502w3b22">
              <motion.div key={index} initial={{
              opacity: 0,
              x: 40
            }} animate={{
              opacity: 1,
              x: 0
            }} exit={{
              opacity: 0,
              x: -40
            }} transition={{
              duration: 0.3,
              ease: 'easeOut'
            }} data-id="element-212" data-mp="1siect8kymttj">
                <Card t={topTestimonials[index]} data-id="element-213" data-mp="1ej4tw15ddllv" />
              </motion.div>
            </AnimatePresence>
          </div>

          <div className="mt-5 flex items-center justify-between" data-id="element-214" data-mp="19rwjp2w7tw7n">
            <button type="button" onClick={() => go(-1)} aria-label="Testimonianza precedente" className="flex h-11 w-11 items-center justify-center rounded-full border border-cobalt/30 text-cobalt-deep transition-colors hover:bg-cobalt/10" data-id="element-215" data-mp="19qlfx32rsogj">
              <ChevronLeftIcon className="h-5 w-5" aria-hidden="true" data-id="element-216" data-mp="qtk8lblquc9f" />
            </button>

            <div className="flex gap-2" data-id="element-217" data-mp="32gw78o5mksgn">
              {topTestimonials.map((_, i) => <button key={i} type="button" onClick={() => setIndex(i)} aria-label={`Vai alla testimonianza ${i + 1}`} className={`h-2 rounded-full transition-all ${i === index ? 'w-6 bg-cobalt' : 'w-2 bg-cobalt/30'}`} data-id="element-218" data-mp="32j9ysn13jmjg" data-mpi={i} />)}
            </div>

            <button type="button" onClick={() => go(1)} aria-label="Testimonianza successiva" className="flex h-11 w-11 items-center justify-center rounded-full border border-cobalt/30 text-cobalt-deep transition-colors hover:bg-cobalt/10" data-id="element-219" data-mp="2jol8n6i07goc">
              <ChevronRightIcon className="h-5 w-5" aria-hidden="true" data-id="element-220" data-mp="20zwud3e109lj" />
            </button>
          </div>
        </div>
      </div>
    </section>;
}